<template>
  <div v-bind:class="{ picker: true, active: active }">

    <div class="full-height pickerListContainer" v-if="showList && active">

      <picture-wall-list
      :list-data="data"
      v-if="type == 'pictureWalls'" ></picture-wall-list>

      <background-list
      :list-data="data"
      v-if="type == 'backgrounds'" ></background-list>

    </div> <!-- showList -->

  </div> <!-- picker -->

</template>

<script>

import PictureWallList from 'components/Lists/PicturewallList'
import BackgroundList from 'components/Lists/BackgroundList'

export default {

  components: {
    PictureWallList,
    BackgroundList,
  },

  data: function(){
    return{
      active: false,
      data: false,
      showList: false,
      error: false,
    }
  },

  computed: {

    type(){
      return this.$store.state.currentPicker;
    },

  },

  methods: {

  	get: function(){

      var self = this;

       // Start loading
      self.$store.commit('startLoading', 'picker');


      // Get data from API if exists
      if(window.apiHandler[self.type]){


        // API returns the data after ajax loading
        window.apiHandler[self.type](function(data){

          // Set data
          self.$set(self, 'data', data);

          // Stop loading
          self.$store.commit('stopLoading', 'picker');

          // Activate picker
          self.$set(self, 'active', true)
          self.$set(self, 'showList', true)
        });

      }
      // Function does not exist in API
      else{
        self.$set(self, 'error', true)
      }

  	},

    close: function(){
      this.$set(this, 'active', false);
      this.$set(this, 'showList', false);
      this.resetPickerData()
    },

    pickedItem: function(pickData){
      this.$emit('pick', pickData);
    }

  },

  created: function () {
   	var self = this;


    // When this picker is opened
   	window.eventHub.$on('openPicker', function (data) {

      var type = data.toString();

      // Close if already open
      if(self.active && self.type == type && type != 'articles'){
         self.close();
         return true;
      }

      // Else just close current
      self.close();

      // Wait until vue has rendered
      window.vueRender(function(){

        self.closePickers('picker')
        self.$store.commit('currentPicker', type)
        self.$store.commit('leftTitle', self.$t(type))
        self.get();

      })

  	});

    // Close picker event
    window.eventHub.$on('closePickers', function (type) {
      if(type != 'picker')
        self.close();
    });

  }

}
</script>

<style>
.picker {
  width: 100%;
  overflow: hidden;
  -webkit-transform: translate3d(-100%,0,0);
  transform: translate3d(-100%,0,0);
  -webkit-transition: -webkit-transform 0.2s;
  transition: -webkit-transform 0.2s;
  -o-transition: transform 0.2s;
  transition: transform 0.2s;
  transition: transform 0.2s, -webkit-transform 0.2s;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.3, 1);
  height: 0;
}

.picker.active{
  height: 100%;
	-webkit-transform: translate3d(0,0,0);transform: translate3d(0,0,0);
}

</style>



// WEBPACK FOOTER //
// Picker.vue?39b5f348